module.exports = __webpack_public_path__ + "c519e9b1bae09ee95355e5e35bcd1d0e.svg";